// components/FooterPage.tsx
import { useState, useEffect } from "react";

interface FooterPageProps {
  onBackToTop: () => void;
}

export default function FooterPage({ onBackToTop }: FooterPageProps) {
  const year = new Date().getFullYear();
  const [isRed, setIsRed] = useState(false);

  // Bascule automatique toutes les 2 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setIsRed((prev) => !prev);
    }, 2000); // 2 secondes

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="footer-page">
      {/* ── Fond animé (inchangé) ── */}
      <div className="footer-page-bg">
        <div className="footer-page-blob footer-page-blob-1" />
        <div className="footer-page-blob footer-page-blob-2" />
        <div className="footer-page-blob footer-page-blob-3" />
        <div className="footer-page-grid" />
        <div className="footer-page-rings">
          <div className="footer-page-ring" />
          <div className="footer-page-ring" style={{ animationDelay: "0.5s" }} />
          <div className="footer-page-ring" style={{ animationDelay: "1s" }} />
        </div>
        <div className="footer-page-waves">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="footer-page-wave">
            <path d="M0,60 C150,120 350,0 500,60 C650,120 850,0 1000,60 C1150,120 1200,60 1200,60 L1200,120 L0,120 Z" />
          </svg>
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="footer-page-wave footer-page-wave-2">
            <path d="M0,60 C150,0 350,120 500,60 C650,0 850,120 1000,60 C1150,0 1200,60 1200,60 L1200,120 L0,120 Z" />
          </svg>
        </div>
      </div>

      <div className="footer-page-inner">
        {/* Bouton retour */}
        <button className="footer-page-back-btn" onClick={onBackToTop} aria-label="Retour en haut">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 19V5M5 12l7-7 7 7" />
          </svg>
        </button>

        {/* Logo avec bascule automatique */}
        <div className="footer-page-logo-wrapper">
          {/* Logo blanc */}
          <img
            src="/photos/ATR_RGB_White.png"
            alt="ATR"
            className="footer-page-logo footer-page-logo-white"
            style={{ opacity: isRed ? 0 : 1 }}
          />
          {/* Logo rouge */}
          <img
            src="/photos/ATR_RGB_Radiant_Sun.png"
            alt="ATR"
            className="footer-page-logo footer-page-logo-red"
            style={{
              opacity: isRed ? 1 : 0,
              filter: isRed
                ? "drop-shadow(0 0 30px rgba(235,40,15,0.6)) drop-shadow(0 0 60px rgba(235,40,15,0.2))"
                : "none",
            }}
          />
        </div>

        {/* Liens */}
        <div className="footer-page-links">
          <a href="https://www.atr-aircraft.com/disclaimer/" target="_blank" rel="noopener noreferrer">Disclaimer</a>
          <span className="footer-page-sep">•</span>
          <a href="https://www.atr-aircraft.com/cookie-policy/" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
          <span className="footer-page-sep">•</span>
          <a href="https://www.atr-aircraft.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <span className="footer-page-sep">•</span>
          <a href="https://www.atr-aircraft.com/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
        </div>

        {/* Copyright */}
        <div className="footer-page-copyright">© {year} ATR – All rights reserved</div>
      </div>
    </div>
  );
}